<template>
	<div v-loading="loading">
		<div>
			<div class="first_line">
				<div class="right_warp">
					<el-select size="small" v-model="filter.storeId" multiple placeholder="请选择" collapse-tags>
						<el-option v-for="item in statelist" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
						<el-option v-for="item in storeEnd" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-date-picker size="small" value-format="yyyy-MM-dd" v-model="filter.date" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
					<el-button type="primary" @click="getlist()" size="small" style=" margin: 5px;">筛选</el-button>
				</div>
			</div>
			<div style="display: flex;float: right;">
				<el-button type="primary" @click="plsc" size="small" style=" margin: 5px;">导入排班</el-button>
				<input type="file" name="file" style="opacity: 0;position: absolute;display: none;" id="sj"
					@change="xuanzhe($event)" />
				<el-button type="primary" @click="exportss" size="small" style=" margin: 5px;">导出</el-button>
			</div>
		</div>
		<div>
			<template>
				<el-table :data="dataTable" id="chart" height='55vh' ref="tableRef" border style="width:100%;"
					@cell-click="cellclick" :header-cell-style="{'color':'#000','font-weight':'bold'}">
					<el-table-column fixed label="门店" width="120">
						<template slot-scope="{ row }">
							{{row.storeName}}
						</template>
					</el-table-column>
					<el-table-column v-for="j in dateTemp.length" :label="dateTemp[j-1]" width="160">
						<template slot-scope="{ row }">
							<span v-for="i in dataTable.length">
								<div v-for="k in row.schedulingList"
									v-if="dataTable[i-1].storeId==k.storeId && k.date==dateTemp0[j-1]"
									style="color:#5A6073">
									<div v-if="dateTemp0[j-1] == today" style="color: #9E1E23;">
										<!-- 	{{k.name+"\0"}}{{k.droster=="-1"?"休息":k.droster}} -->
										{{k.name+"\0"}}{{k.droster=="-1"?"休息":(k.half==null?k.droster:"请半天假")}}
									</div>
									<div v-else>
										{{k.name+"\0"}}{{k.droster=="-1"?"休息":(k.half==null?k.droster:"请半天假")}}
									</div>
								</div>
							</span>
						</template>
					</el-table-column>
				</el-table>
			</template>
		</div>
		<div style="height: 3vh;"></div>
		<div>
			<el-row :gutter="24">
				<el-col :span="17">
					<div v-if="this.selectObj.storeName">
						<div class="bigText"> {{this.rosterDate}}--{{this.selectObj.storeName}}</div>
						<template>
							<el-table :data="sDateWorker" border style="width=100%; vertical-align:middle;">
								<el-table-column prop="name" label="姓名" width="120">
								</el-table-column>
								<el-table-column prop="droster" label="班次" width="120">
									<template slot-scope="{row}">
										<!-- <div style="width: 80px;background-color: #f0f0f0;text-align: center;"> -->
										<el-popover trigger="click">
											<el-button type="text" slot="reference"
												@click="selectObj.workerId=row.workerId,selectObj.name=row.name,selectObj.phone=row.phone"
												class="upbtn">{{row.type=="0"?row.droster:"暂无安排"}}
											</el-button>
											<div>
												<div v-for="item in rosterList" :key="item.id"
													style="margin: 5px 5px 10px 5px;">
													<el-radio v-model="selectObj.droster" :label="item.desc">
														<!-- <span>{{ item.startWorkTime.substring(0, 5) + "-" + item.endWorkTime.substring(0, 5) }}</span> -->
														<span>{{item.desc}}</span>
													</el-radio>
												</div>
												<div style="margin-left:150px">
													<el-button type="text" size="mini"
														@click="workRoster(row.id,row.workerId,0)">
														保存
													</el-button>
												</div>
											</div>
										</el-popover>
										<!-- </div> -->
									</template>
								</el-table-column>
								<el-table-column label="午餐时间" width="260">
									<templete slot-scope="{row}">
										<el-select v-model="row.lunchStartTime" placeholder="午餐开始时间" clearable
											size="small" class="wtime" @change="saveChange(row)">
											<el-option v-for="item in timeLunchStartList" :key="item.value"
												:value="item.value" :label="item.value"></el-option>
										</el-select>
										~
										<el-select v-model="row.lunchEndTime" placeholder="午餐结束时间" clearable
											size="small" class="wtime" @change="saveChange(row)">
											<el-option v-for="item in timeLunchEndList" :key="item.value"
												:value="item.value" :label="item.value"></el-option>
										</el-select>
									</templete>
								</el-table-column>
								<el-table-column label="晚餐时间" width="260">
									<templete slot-scope="{row}">
										<el-select v-model="row.dinnerStartTime" placeholder="晚餐开始时间" clearable
											size="small" class="wtime" @change="saveChange(row)">
											<el-option v-for="item in timeDinnerStartList" :key="item.value"
												:value="item.value" :label="item.value"></el-option>
										</el-select>
										~
										<el-select v-model="row.dinnerEndTime" placeholder="晚餐结束时间" clearable
											size="small" class="wtime" @change="saveChange(row)">
											<el-option v-for="item in timeDinnerEndList" :key="item.value"
												:value="item.value" :label="item.value"></el-option>
										</el-select>
									</templete>
								</el-table-column>
								<el-table-column prop="type" label="状态" width="100">
									<templete slot-scope="{row}">
										{{ row.type | typeFormat1}}
									</templete>
								</el-table-column>
								<el-table-column label="操作" width="200">
									<template slot-scope="{row}">
										<el-popover v-if="row.type=='0'">
											<el-button type="text" size="mini" slot="reference"
												@click="deleteRoster(row.id)" class="upbtn">休息</el-button>
										</el-popover>
										<el-popover v-else trigger="click">
											<el-button type="text" size="small" slot="reference"
												@click="selectObj.workerId=row.workerId,selectObj.name=row.name,selectObj.phone=row.phone"
												class="upbtn">上班
											</el-button>
											<div>
												<div v-for="item in rosterList" :key="item.id"
													style="margin: 5px 5px 10px 5px;">
													<el-radio v-model="selectObj.droster" :label="item.desc">
														<span>{{item.desc}}</span>
														<!-- <span>{{ item.startWorkTime.substring(0, 5) + "-" + item.endWorkTime.substring(0, 5) }}</span> -->
													</el-radio>
												</div>
												<div style="margin-left:150px">
													<el-button type="text" size="mini"
														@click="workRoster(row.id,row.workerId,0)">
														保存
													</el-button>
												</div>
											</div>
										</el-popover>
										<el-button type="text" size="small"
											@click="rosterShow=true,selectObj.outWorker=row.name,selectObj.date=this.rosterDate">
											调店</el-button>
										<el-button @click="saveWorkerStatus(row.workerId,1)" type="text" size="small">
											加入机动组
										</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
					</div>
				</el-col>
				<el-col :span="7">
					<div style="background-color: #fbfbfb;min-height: 100px; padding: 0 10 0 10;">
						<span>机动组</span>
						<div style="display: flex;flex-wrap: wrap;">
							<div v-for=" i in workerList" v-if="i.motor==1" tabindex="item.index" class="divBack">
								<el-tag :closable="jidongShow" @close="deljiDong(i.id,0)"
									@click="check(i.id,i.name,i.telphone) " class=" jidongbtn">{{i.name}}
								</el-tag>
							</div>
						</div>
						<el-popover trigger="click">
							<el-button type="text" size="small" slot="reference"
								@click="selectObj.workerId=i.id,selectObj.name=i.name,selectObj.phone=i.telphone"
								class="upbtn">加入排班
							</el-button>
							<div>
								<div v-for="item in rosterList" :key="item.id" style="margin: 5px 5px 10px 5px;">
									<el-radio v-model="selectObj.droster" :label="item.desc">
										<!-- <span>{{ item.startWorkTime.substring(0, 5) + "-" + item.endWorkTime.substring(0, 5) }}</span> -->
										<span>{{item.desc}}</span>
									</el-radio>
								</div>
								<div style="margin-left:150px">
									<el-button type="text" size="mini" @click="workRoster(0,jiDongcheck,0)">
										保存
									</el-button>
								</div>
							</div>
						</el-popover>
						<el-button type="text" size="small" class="red" @click="jidongShow=!jidongShow">
							移除</el-button>
						<el-button type="primary" size="small" @click="firstAddJiDong()"
							style="display: flex;float: right;">
							添加机动组</el-button>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-dialog :visible.sync="addWorker" @close="close" width="20%">
			<div style="font-size: 16px; height:auto; margin-bottom:5px;">
				<div style="text-align:center;vertical-align:middel;">
					<p1>添加机动组成员</p1>
					</br>
					<input type="text" v-model="workerList1.name" @keydown.enter="getWorkerList1(workerList1.name)"
						placeholder="输入发型师姓名" style="font-size:15px;padding: 5px;margin:15px;">
				</div>
				<div>
					<el-radio-group v-model="radio">
						<el-radio v-for="j in workerList1" v-if="j.status!=8"
							@click.native.prevent="check(j.id,j.name,j.phone)">
							{{j.name}}———{{j.storeName}}
						</el-radio>
					</el-radio-group>
				</div>
				<el-button type="primary" style="margin-left: 40%; margin-top: 15px;"
					@click="saveWorkerStatus(jiDongcheck,1)">确定
				</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="rosterShow " @close="close" width="30%">
			<div style="font-size: 16px; margin-bottom:10px;">
				<b style="font-size:16px;">所选发型师：</b>
				<span>
					{{ selectObj.outWorker }}
				</span>
			</div>
			<div style="font-size: 16px; margin-bottom:10px;">
				<b style="font-size:16px;">排班时间：</b>
				<span>
					{{ selectObj.date }}
				</span>
			</div>
			<div style="font-size: 16px; font-weight:700; margin-bottom:10px;">
				<b style="font-size:16px;">门店选择：</b>
				<el-select v-model="selectObj.outStorename" filterable @change="getRosters(selectObj.outStorename)"
					size="small" style="width:300px;">
					<el-option v-for="item in statelist" :key="item.label" :label="item.label" :value="item.label">
					</el-option>
				</el-select>
			</div>
			<div style="height:100px;">
				<b style="font-size:16px;">班次选择：</b>
				<el-select v-model="outRoster" filterable size="small" style="width:300px;">
					<el-option v-for="item in storeRosters" :key="item.desc" :label="item.desc" :value="item.desc">
					</el-option>
				</el-select>
			</div>
			<div>
				<el-button type="primary" style="margin-left:70%" @click="outStore">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	let that
	import {
		url
	} from "../../../utils/index.js"
	export default {
		inject: ['reload'],
		data() {
			return {
				today: '',
				rosterSid: "7",
				rosterDate: new Date(),
				row: '',
				column: '',
				worker: {},
				changetime: false,
				loading: false,
				loading2: false,
				del: false,
				outRoster: undefined,
				url: url(),
				filter: {
					city: "", //城市
					date: [],
					startTime: "", // 开始时间
					endTime: "", // 结束时间
					// storeId:[],
				},
				workerName: "", //输入的发型师名
				selectDate: '', //点击日历的日期
				workerList: {
					id: '',
					name: "",
					storeName: "",
					motor: '',
				},
				workerList1: {
					id: '',
					name: "",
					storeName: "",
					motor: '',
					status: "",
				},
				jiDongcheck: undefined,
				tagName: undefined,
				tagPhone: undefined,
				restWorker: [],
				addWorker: false,
				rosterShow: false,
				closable: false,
				jidongShow: false,
				radio: {},
				statelist: [],
				storeEnd: [],
				selectObj: {
					date: undefined,
				},
				sDate: {}, //根据门店ID和日期返回的排班列表
				storeWorker: [],
				selectWorkers: [],
				citys: [],
				// 日历
				newrili: new Date(),
				dataTable: [],
				dataTable1: [],
				date: "",
				rosterList: [],
				otherWorker: [],
				storeRosters: [],
				tableData: [{
					storeName: '公园前',
					date: "周一 2022-7-15"
				}, {
					storeName: '坑口',
					date: "周二 2022-7-16"
				}, {
					storeName: '鹭江',
					date: "周三 2022-7-17"
				}, {
					storeName: '鹭江',
					date: "周四 2022-7-18"
				}, ],
				timeLunchStartList: [{
					id: 0,
					value: '12:00:00'
				},{
					id: 1,
					value: '12:15:00'
				},{
					id: 2,
					value: '12:30:00'
				},{
					id: 3,
					value: '12:45:00'
				},{
					id: 4,
					value: '13:00:00'
				}, {
					id: 5,
					value: '13:15:00'
				}, {
					id: 6,
					value: '13:30:00'
				}, {
					id: 7,
					value: '13:45:00',
				}, {
					id: 8,
					value: '14:00:00'
				}, {
					id: 9,
					value: '14:15:00',	
				}, {
					id: 10,
					value: '14:30:00'
				}, {
					id: 11,
					value: '14:45:00',
				}, {
					id: 12,
					value: '15:00:00'	
				}, ],
				timeLunchEndList: [{
					id: 0,
					value: '13:15:00'
				}, {
					id: 1,
					value: '13:30:00'
				}, {
					id: 2,
					value: '13:45:00'
				}, {
					id: 3,
					value: '14:00:00'
				}, {
					id: 4,
					value: '14:15:00'
				},{
					id: 5,
					value: '14:30:00'
				},{
					id: 6,
					value: '14:45:00'
				},{
					id: 7,
					value: '15:00:00',
				}, {
					id: 8,
					value: '15:15:00'
				}, {
					id: 9,
					value: '15:30:00',	
				}, {
					id: 10,
					value: '15:45:00'
				}, {
					id: 11,
					value: '16:00:00',
				}, {
					id: 12,
					value: '16:15:00'		
				}
				],
				timeDinnerStartList: [{
					id: 4,
					value: '18:00:00'
				}, {
					id: 5,
					value: '18:15:00'
				}, {
					id: 6,
					value: '18:30:00'
				}, {
					id: 7,
					value: '18:45:00'
				}, {
					id: 8,
					value: '19:00:00'
				}, {
					id: 7,
					value: '19:15:00'
				}, {
					id: 9,
					value: '19:30:00'
				}, ],
				timeDinnerEndList: [{
					id: 4,
					value: '18:15:00'
				}, {
					id: 5,
					value: '18:30:00'
				}, {
					id: 6,
					value: '18:45:00'
				}, {
					id: 1,
					value: '19:00:00'
				}, {
					id: 7,
					value: '19:15:00'
				}, {
					id: 2,
					value: '19:30:00'
				}, {
					id: 7,
					value: '19:45:00'
				}, {
					id: 3,
					value: '20:00:00'
				}],
				selectDate1: [],
				dateTemp0: [],
				dateTemp: [],
			};
		},
		created() {
			that = this;
			this.dataTable = []
		},
		mounted() {
			this.onloads = true,
				this.getstorelist();
			// this.getlist()
			// this.getWorkerList();
			this.rosterByDateWorker();
			// this.getRosterList();
		},
		computed: {
			zhuan: () => {
				return (value) => {
					if (!that.list) return null
					let str = "";
					that.list.filter(ele => str += ele.date == value ? ele.name + "," : "");
					return str.substring(0, str.length - 1);
				}
			},
		},
		filters: {
			eTime(val) {
				if (val != null) {
					val = val.slice(0, 5)
				}
				return val;
			},
			//首次进入正常显示，但点击其他就变了
			typeFormat1(val) {
				switch (val) {
					case "0":
						return "上班";
					case "1":
						return "调休";
					case "2":
						return "请假";
					default:
						return "暂无安排";
				}
			},
		},
		methods: {
			init() {
				let myChart = document.getElementById('chart')
				window.addEventListener("resize", () => {
					myChart.resize();
				})
			},
			cellclick(row, column, cell, event) {
				this.rosterSid = row.storeId;
				this.rosterDate = column.label.slice(0, 10);
				this.row = row;
				this.column = column;
				this.selectObj.date = this.rosterDate
				this.selectObj.storeName = this.row.storeName
				this.selectObj.storeId = row.storeId;
				this.rostreByDate()
				this.rosterByDateWorker()
				// this.getRosterList()
				this.getlist()
				console.log(row)
				console.log(column)
			},
			exportss() {
				let arr = {
					ids: this.filter.storeId.join(",")
				}
				if (this.filter.date) {
					arr.startTime = this.filter.date[0]
					arr.endTime = this.filter.date[1]
				}
				window.location.assign(this.url + "dSchedulingExamine/exporDroster?startTime=" + arr.startTime +
					"&endTime=" + arr.endTime +
					"&ids=" + arr.ids
				)
			},
			getRosterList() {
				this.$http.get("dcheckuser/rosterGroup/store/" + this.rosterSid).then(res => {
					//单元格数据
					this.rosterList = res.body.data
				})
			},
			getRosters(event) {
				var id = this.statelist.filter(ele => event == ele.label)[0].value
				this.$http.get("dcheckuser/rosterGroup/store/" + id).then(res => {
					this.storeRosters = res.body.data
				})
			},
			selectWorker(roster) {
				let arr = [];
				roster.workers.forEach(ele => {
					arr.push(ele.name)
				});
				this.selectObj.selectRoster = JSON.parse(JSON.stringify(roster));
				this.selectWorkers = arr;
				this.rosterShow = true;
			},
			saveWorkerStatus(id, motor) {
				var arr = {
					id: id,
					motor: 1
				}
				this.$http.post("dWorker/saveOrUpdate", JSON.stringify(arr)).then(res => {
					if (res.body.code == 200) {
						this.$message.success("更改成功")
						this.addWorker = false
						this.getWorkerList()
					}
				})
				this.addWorker = false
			},
			check(id, name, telphone) {
				this.jiDongcheck = id
				this.tagName = name
				this.tagPhone = telphone
			},
			getWorkerList1(name) {
				this.$http.get("dWorker/queryAll" + "?name=" + name).then(res => {
					this.workerList1 = res.body.data;
				})
			},
			deljiDong(id, motor) {
				this.$confirm('移除该发型师, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var a = {
						id: id,
						motor: 0
					}
					this.$http.post("dWorker/saveOrUpdate", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.$message.success("移除成功")
						} else {
							this.$message.success("移除失败")
						}
						this.getWorkerList()
					})
				})
			},
			firstAddJiDong() {
				this.workerList1 = {}
				this.addWorker = true
			},
			getWorkerList() {
				this.$http.get("dWorker/query?filterOut=1").then(res => {
					this.workerList = res.body.data;
					this.worker = res.body.data;
					this.storeWorker.length = 0;
					this.storeWorker = this.workerList.filter(ele => ele.storeId == this.rosterSid);
				})
			},
			// 休息(排班ID)
			deleteRoster(id) {
				this.$confirm("是否确定休息?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}).then(() => {
					this.loading = false
					this.$http.get("dcheckuser/deleteRoster" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.loading = false
							this.rostreByDate();
							this.rosterByDateWorker();
							this.getlist();
							this.selectObj.workerId = undefined;
							this.selectObj.droster = undefined;
							this.$message.success("休息成功");
						} else {
							this.$message.error(res.body.msg)
						}
					})
				})
			},
			// 新增排班
			workRoster(id, workerId, type) {
				this.loading = true
				if (!workerId) {
					if (!this.selectObj.droster) return this.$message.error("保存失败，没有选择班次！");
				}
				this.selectObj.storeName = this.statelist.filter(res => res.value == this.rosterSid)[0].label
				this.selectObj.storeId = this.rosterSid
				this.selectObj.selectDate = this.rosterDate
				this.selectObj.workerId = workerId
				this.selectObj.name = this.tagName
				this.selectObj.phone = this.tagPhone
				this.selectObj.id = id
				if (type != null) {
					this.selectObj.type = type
				}
				this.$http.post("dcheckuser/roster/work", JSON.stringify(this.selectObj)).then(res => {
					if (res.body.code == 200) {
						this.loading = false
						this.rostreByDate();
						this.rosterByDateWorker();
						this.getlist();
						this.selectObj.workerId = undefined;
						this.selectObj.droster = undefined;
						this.$message.success("保存成功")
					} else {
						this.loading = false
						this.$notify({
							title: '排班重复',
							message: res.body.msg,
							customClass: "not", //自定义类名
							duration: 0
						});
					}
				})
			},
			handleClose(item) {
				this.$confirm('移除该发型师, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var a = {
						id: item.id,
						userId: item.userId,
						couponTitle: item.title,
						code: item.code
					}
					this.$http.post("user/deleteCoupon", JSON.stringify(a)).then(res => {
						if (res.body.code == 200) {
							this.getInfo()
							this.$message.success("移除成功")
						} else {
							this.$message.success("移除失败")
						}
					})
				}).catch(() => {
					this.$message.success("已取消移除")
				});
			},
			close() {
				this.selectObj.outWorker = undefined;
				this.outRoster = undefined;
				this.selectObj.outStorename = undefined;
				this.storeRosters = [];
			},
			outStore() {
				let data = {
					date: this.selectObj.date,
					worker: this.selectObj.outWorker,
					roster: this.outRoster,
					storeName: this.selectObj.outStorename
				};
				this.$http.post("dcheckuser/updateRoster", JSON.stringify(data)).then(res => {
					if (res.body.code == 200) {
						this.getlist();
						setTimeout(() => this.rostreByDate(), 1000);
						setTimeout(() => this.rosterByDateWorker(), 1000);
						this.rosterShow = false;
						this.$message.success("保存成功")
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			rostreByDate() {
				let data;
				data = {
						storeId: this.rosterSid,
						date: this.rosterDate
					},
					this.selectObj.date = data.date;
				this.$http.post("dcheckuser/rosterByDate", JSON.stringify(data)).then(res => {
					this.sDate = res.body.data
					if (res.body.code == 200) {
						var b = {
							edit: false
						}
						this.rosterList.forEach(ele => {
							let d = res.body.data.filter(worker => worker.droster == ele.desc);
							this.$set(ele, 'workers', d);
						})
						this.restWorker.length = 0;
						this.storeWorker.forEach(ele => {
							if (res.body.data.filter(worker => worker.name == ele.name).length == 0) this
								.restWorker.push(ele);
						})
						this.loading2 = false
					}
				})
			},
			rosterByDateWorker() {
				let data;
				data = {
						storeId: this.rosterSid,
						date: this.rosterDate,
					},
					this.$http.post("dcheckuser/rosterByDateWorker", JSON.stringify(data)).then(res => {
						this.sDateWorker = res.body.data
					})
			},
			changeTime(worker) {
				this.changetime = true
				this.worker = worker
			},
			saveChange(row) {
				console.log(row)
				if (row.id != 0) {
					var c = row
					var x = new Date().getFullYear();
					console.log(x)
					var ls = new Date(x + '-01-01 ' + c.lunchStartTime)
					var le = new Date(x + '-01-01 ' + c.lunchEndTime)
					var ds = new Date(x + '-01-01 ' + c.dinnerStartTime)
					var de = new Date(x + '-01-01 ' + c.dinnerEndTime)
					if ((le.getTime() - ls.getTime() > 0) || (c.lunchStartTime == null && c.lunchEndTime == null)) {
						if ((de.getTime() - ds.getTime() > 0) || (c.dinnerStartTime == null && c.dinnerEndTime == null)) {
							var a = {
								id: c.id,
								lunchStartTime: c.lunchStartTime,
								lunchEndTime: c.lunchEndTime,
								dinnerStartTime: c.dinnerStartTime,
								dinnerEndTime: c.dinnerEndTime
							}
							this.$http.post("dcheckuser/roster/changeEatTime", JSON.stringify(a)).then(res => {
								if (res.ok == true) {
									this.$message.success("修改成功")
									this.changetime = false
									this.rostreByDate()
									this.rosterByDateWorker()
									this.worker = {}
								} else {
									this.$message.error("修改失败")
								}
							})
						}
					}
				} else {
					this.$message.error("当天没有排班")
				}
			},
			getstorelist() {
				this.$http.get("store/list").then((res) => {
					var i = 0;
					if (res.body.code == "200") {
						this.statelist = []
						this.storeEnd = []
						res.body.data.forEach(ele => {
							if (ele.businessType === 0) {
								this.statelist.push({
									value: ele.id,
									label: ele.title,
								})
								if (ele.id != 46) {
									this.filter.storeId.[i++] = ele.id
								}
							} else {
								this.storeEnd.push({
									value: ele.id,
									label: ele.title,
								})
							}
						})
						this.getlist();
					} else {
						this.$message.error("请求失败")
					}
				})
			},
			// 文件上传
			plsc: function() {
				var sj = document.querySelector('#sj')
				sj.click()
			},
			xuanzhe: function(val) {
				var sj = document.querySelector('#sj')
				let Formdata = new FormData;
				Formdata.append('file', val.target.files[0])
				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
				var that = this
				this.$http.post("dcheckuser/drosterCheckUserImport", Formdata, config).then(function(
					res) {
					if (res.body.code == 200) {
						this.$message.success("导入成功")
						this.rostreByDate()
						this.rosterByDateWorker()
						// this.getRosterList()
						this.getlist()
					} else {
						this.$message.error(res.body.msg)
					}
					// var t0 = setTimeout(function() {
					// 	this.$message.info("页面即将刷新")
					// },1000);
					var t = setTimeout(function() {
						// location.reload()
						// this.$router.go(-1)
						// this.$parent.reload()
						// this.reload();
						that.reload()
					}, 4000);
				})
			},
			getlist() {
				this.loading = true;
				let t = setTimeout(() => { //15秒超时
					this.loading = false
					this.$message.error("请求失败")
				}, 15000)
				var flag0;
				var flag1;
				let arr = {
					ids: this.filter.storeId,
				}
				this.statelist.map(ele => {
					if (ele.value == arr.ids) arr.name = ele.label
				})
				if (this.onloads == true) {
					flag0 = 7;
					flag1 = 9;
				} else {
					flag0 = Math.floor((new Date() - new Date(this.filter.date[0])) / (24 * 3600 *
						1000)); //开始时间距离今天有多少天
					flag1 = Math.floor((new Date(this.filter.date[1]) - new Date()) / (24 * 3600 *
						1000)); //开始时间距离今天有多少天
				}
				var myDate = new Date(); //获取今天日期
				myDate.setDate(myDate.getDate() - flag0);
				var date0;
				var date;
				var flag = 1;
				let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
				this.dateTemp = []
				this.dateTemp0 = []
				for (var i = 0; i < (flag0 + flag1 + 2); i++) {
					let wk = myDate.getDay()
					let week = weeks[wk]
					this.nowWeek = week
					// if (i == 0 || i == 13) {
					// 	date1 = (myDate.getFullYear()) + "-" +
					// 		((myDate.getMonth() + 1) > 9 ? (myDate.getMonth() + 1) : ('0' + (myDate
					// 			.getMonth() + 1))) + '-' +
					// 		(myDate.getDate() > 9 ? myDate.getDate() : ('0' + myDate.getDate()))

					// 	this.selectDate1.push(date1);
					// 	this.filter.date = this.selectDate1
					// }
					var a = myDate.getFullYear();
					var b = myDate.getMonth() + 1;
					var c = myDate.getDate();
					date0 = (a) + "-" +
						(b > 9 ? b : ('0' + b)) + '-' +
						(c > 9 ? c : ('0' + c));
					date = (a) + "-" +
						(b > 9 ? b : ('0' + b)) + '-' +
						(c > 9 ? c : ('0' + c)) + this.nowWeek;
					this.dateTemp0.push(date0);
					this.dateTemp.push(date);
					myDate.setDate(myDate.getDate() + flag);
					if (this.onloads = true) {
						if (i == 0) {
							this.filter.date[0] = date0
						}
						if (i == (flag0 + flag1 + 1)) {
							this.filter.date[1] = date0
						}
						if (i == 7) {
							this.today = date0
						}
					}
				}
				if (this.filter.date) {
					arr.startTime = this.filter.date[0]
					arr.endTime = this.filter.date[1]
				}
				this.$http.post("dcheckuser/findDSchedulingDate1", JSON.stringify(arr)).then(res => {
					this.$nextTick(() => {
						this.dataTable = res.body.data
						this.$refs.tableRef.doLayout()
						// let a = document.getElementById('chart')
						// window.addEventListener("resize",()=>{
						// 	a.resize();
						// })
					})
				})
				this.init()
				this.getWorkerList();
				this.getRosterList();
				this.onloads = false;
				// this.init()
				// let myChart = document.getElementById('chart')
				// window.addEventListener("resize", () => {
				// 	myChart.resize();
				// }),
				this.loading = false
				clearTimeout(t)
			},
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		margin: 20px 0;
		display: flex;
		justify-content: space-between;
		display: inline-block;
		// margin-bottom: 10px;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 200px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.red {
		color: red;
	}

	.divBack {
		margin-right: 15px;
	}

	.divBack:active {
		background-color: aquamarine;
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.upbtn {
		margin-right: 5px;
	}

	.jidongbtn {
		color: #000;
		margin: 5px;
		// background-color: #fff;
		border: #fafafa;
		padding: 5px;
	}

	.b {
		background-color: red;
	}

	.el-notification {
		white-space: pre !important;
	}

	.not {
		word-wrap: break-word;
		word-break: break-all;
	}

	.bigText {
		font-size: 18px;
		color: #000000;
		font-family: SourceHanSansCN-Bold;
	}

	.wtime {
		width: 100px;
	}

	/deep/ .el-input__inner {
		-webkit-appearance: none;
		background-color: transparent;
		background-image: none;
		// border-radius: 4px;
		// border: 1px solid #DCDFE6;
		box-sizing: border-box;
		color: #606266;
		// display: inline-block;
		font-size: 10px;
		height: 30px;
		// line-height: 40px;
		// outline: 0;
		// padding: 0 15px;
		// transition: border-color .2s cubic-bezier(.645,.045,.355,1);
		// width: 100%;
	}

	div:focus {
		background-color: red;
	}

	/deep/ .el-table__body .hover-row>td {}
</style>